import { useState } from 'react';

interface TryonModel {
  id: string;
  name: string;
  gender: string;
  image: string;
}

interface ModelGalleryProps {
  models: TryonModel[];
  selectedModelId: string | null;
  onSelect: (model: TryonModel) => void;
}

export default function ModelGallery({ models, selectedModelId, onSelect }: ModelGalleryProps) {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<'all' | 'female' | 'male'>('all');

  const filtered = models.filter((m) => {
    if (filter === 'all') return true;
    return m.gender === filter;
  });

  const tabs = [
    { id: 'all' as const, label: t('tryon_model_all', '全部') },
    { id: 'female' as const, label: t('tryon_model_female', '女模') },
    { id: 'male' as const, label: t('tryon_model_male', '男模') },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: 'linear-gradient(135deg, #EC4899, #F97316)' }}>
            <i className="ri-user-star-line text-white text-xs"></i>
          </div>
          <span className="text-xs font-semibold text-gray-500">{t('tryon_chooseModel', '选择模特')}</span>
        </div>
        <div className="flex items-center gap-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setFilter(tab.id)}
              className={`px-2.5 py-0.5 rounded-full text-[11px] font-medium cursor-pointer transition-all whitespace-nowrap ${
                filter === tab.id
                  ? 'text-white'
                  : 'text-gray-400 hover:text-gray-500'
              }`}
              style={
                filter === tab.id
                  ? { background: 'linear-gradient(135deg, #FF6B9D, #A855F7)' }
                  : { background: 'rgba(0,0,0,0.04)' }
              }
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-2.5 overflow-x-auto pb-1" style={{ scrollbarWidth: 'none' }}>
        {filtered.map((model) => {
          const isSelected = selectedModelId === model.id;
          return (
            <button
              key={model.id}
              onClick={() => onSelect(model)}
              className="flex-shrink-0 flex flex-col items-center gap-1 cursor-pointer active:scale-95 transition-transform"
            >
              <div
                className="relative w-16 h-24 rounded-xl overflow-hidden"
                style={{
                  border: isSelected ? '2px solid #FF6B9D' : '2px solid transparent',
                }}
              >
                <img
                  src={model.image}
                  alt={model.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                {isSelected && (
                  <div className="absolute inset-0 bg-gradient-to-t from-pink-500/20 to-transparent" />
                )}
                {isSelected && (
                  <div className="absolute bottom-1 right-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center">
                    <i className="ri-check-line text-white text-[11px]"></i>
                  </div>
                )}
              </div>
              <span
                className={`text-[10px] whitespace-nowrap ${
                  isSelected ? 'text-pink-600 font-medium' : 'text-gray-500'
                }`}
              >
                {model.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
